import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WhyChooseUs.css';
import { ROUTES } from '../../utils/routes';

const WhyChooseUs = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(ROUTES.WHY_MS_TECHNOLOGIES);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [whyChooseData, setWhyChooseData] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setWhyChooseData(data.why_choose_us);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <section className="why-section section-pad" id="why">
      <div className="container">
        <div className="row align-items-center ">

          {/* ── Left Image ── */}
          <div className="col-lg-5" data-aos="fade-right" data-aos-duration="800">
            <div className="why-img-wrapper">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${whyChooseData.folder_path}/${whyChooseData.image}`}
                alt="Business Partnership"
                className="why-img"
              />
            </div>
          </div>
          {/* ── Right Content ── */}
          <div className="col-lg-7" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            <div className="why-content">
              <div
                dangerouslySetInnerHTML={{
                  __html: whyChooseData.description || ""
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
